import React from 'react';

export default function Question({ color = '#00528A', ...rest }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8 20L5 17L8 14"
        stroke="#00528A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 4L18.5 7L15.5 10"
        stroke="#00528A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 17L14.5518 17C15.4875 17 16.3937 16.6719 17.1125 16.0729L19 14.5"
        stroke="#00528A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 7L9.15685 7C8.09599 7 7.07857 7.42143 6.32843 8.17157L5 9.5"
        stroke="#00528A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
